import { defineMigrations } from "@supersig/store";
/** @public */ export const imgNodeProps = {};
/** @internal */ export const imgNodeMigrations = defineMigrations({});
export const ImgNodeInfo = {
    migrations: imgNodeMigrations,
    props: imgNodeProps,
    meta: {}
};
